import { render } from "./LastTvAuth.vue?vue&type=template&id=479e6787&scoped=true"
import script from "./LastTvAuth.vue?vue&type=script&lang=js"
export * from "./LastTvAuth.vue?vue&type=script&lang=js"

import "./LastTvAuth.vue?vue&type=style&index=0&id=479e6787&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479e6787"]])

export default __exports__